import { render, staticRenderFns } from "./PlaceRegister.vue?vue&type=template&id=1feb9466&"
import script from "./PlaceRegister.vue?vue&type=script&lang=js&"
export * from "./PlaceRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports